'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const WhatsAppHelper = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  if (!isHydrated) {
    return null;
  }

  const quickQuestions = [
    "How do I start generating carbon credits?",
    "What's the verification process?",
    "Can small businesses participate?",
    "What are the costs involved?"
  ];

  const handleQuestionClick = (question: string) => {
    const encodedQuestion = encodeURIComponent(question);
    window.open(`https://wa.me/1234567890?text=${encodedQuestion}`, '_blank');
  };

  const handleDirectConnect = () => {
    const welcomeMessage = encodeURIComponent('Welcome to Gencarbon - The Best ESG solution for you');
    window.open(`https://wa.me/1234567890?text=${welcomeMessage}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isExpanded && (
        <div className="mb-4 bg-card border border-border rounded-xl shadow-natural-xl p-4 w-80 animate-fade-in">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-heading font-bold text-text-primary">Quick Questions</h4>
            <button
              onClick={() => setIsExpanded(false)}
              className="p-1 hover:bg-surface rounded-lg transition-colors duration-200"
            >
              <Icon name="XMarkIcon" size={20} className="text-text-secondary" />
            </button>
          </div>
          
          <div className="space-y-2">
            {quickQuestions.map((question, index) => (
              <button
                key={index}
                onClick={() => handleQuestionClick(question)}
                className="w-full text-left p-3 bg-surface hover:bg-primary/10 border border-border hover:border-primary/30 rounded-lg text-sm text-text-primary transition-all duration-200"
              >
                {question}
              </button>
            ))}
          </div>
        </div>
      )}
      
      <button
        onClick={handleDirectConnect}
        className="w-14 h-14 bg-conversion text-conversion-foreground rounded-full shadow-natural-lg hover:shadow-natural-xl flex items-center justify-center transition-all duration-300 ease-organic transform hover:scale-110"
      >
        <Icon name={isExpanded ? "XMarkIcon" : "ChatBubbleLeftRightIcon"} size={24} />
      </button>
    </div>
  );
};

export default WhatsAppHelper;